// extracted by mini-css-extract-plugin
export default {"root":"CommonTable_root__64c9c","empty":"CommonTable_empty__poqEe","emptyIcon":"CommonTable_emptyIcon__0-Qw1"};